<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <div class="tfa-container">
      <h2>Passwortänderung erforderlich</h2>
      <v-form
        ref="form"
        v-model="formValid"
        :disabled="submitting"
      >
        <v-container>
          <v-row>
            <v-col
              v-if="errorMessage !== null"
              cols="12"
              md="12"
            >
              <v-alert type="error">
                {{ errorMessage }}
              </v-alert>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="newPassword"
                :rules="passwordRules"
                label="Neues Passwort"
                autocomplete="change-password new-password"
                type="password"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="validateNewPassword"
                :rules="[newPassword === validateNewPassword || 'Die Passwörter stimmen nicht überein']"
                label="Passwort Bestätigen"
                autocomplete="change-password new-password-verification"
                type="password"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex flex-row-reverse">
            <v-btn
              :disabled="!formValid"
              :loading="submitting"
              depressed
              color="primary"
              @click="changePassword"
            >
              Passwort ändern
            </v-btn>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </v-dialog>
</template>
<script>
import ExternalUser from '@/main/ExternalUser';

export default {
  name: 'ChangePasswordPopup',
  props: {},
  data: () => ({
    dialog: true,
    formValid: false,
    submitting: false,
    newPassword: '',
    validateNewPassword: '',
    changedFailed: false,
    errorMessage: null,
    passwordRules: ExternalUser.PASSWORD_RULES
  }),
  methods: {
    show() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    changePassword() {
      if (!this.formValid || this.newPassword !== this.validateNewPassword) return;
      this.submitting = true;
      this.errorMessage = null;

      const password = Buffer.from(this.newPassword, 'utf-8').toString('base64');

      ExternalUser.changePassword(password)
        .then((response) => {
          if (response.status !== 204 && response.status !== 200) {
            this.changedFailed = true;
            return;
          }

          this.$auth.user({
            userName: this.$auth.user().userName,
            userRoles: this.$auth.user().userRoles,
            twoFactorAuthenticated: this.$auth.user().twoFactorAuthenticated,
            passwordResetRequired: false,
          });
          this.$store.commit('loginChange', 'SUCCESS');
          this.$emit('passwordChanged');
        })
        .catch(() => {
          this.changedFailed = true;
          this.errorMessage = 'Das Password konnte nicht geändert werden. Das neue Password darf nicht dem aktuellen entsprechen.';
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  }
};
</script>
<style scoped>
.tfa-container {
  padding: var(--goe-spacing-2);
  background: var(--goe-background-light);
}

.align-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

h2 {
  margin-top: var(--goe-spacing-0_5);
  text-align: center;
  font-size: var(--goe-fontSize-normal);
  color: var(--goe-fontColor-highlight);
  font-weight: var(--goe-fontWeight-bold);
}

.description {
  font-size: var(--goe-fontSize-small);
  color: var(--goe-fontColor-light);
  margin-bottom: var(--goe-spacing-0);
  margin-top: var(--goe-spacing-2);
}

img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
